export const version = 'v4.7.6';
